export const SET_PID_QUERY_SUCCESS = "@pid/set-pid-query-success";
export const SET_PID_TABS_SUCCESS = "@pid/set-pid-tabs-success";

export function setPidQuerySuccess(query) {
  return { type: SET_PID_QUERY_SUCCESS, payload: { query } };
}

export function setPidTabsSuccess(tabs) {
  return { type: SET_PID_TABS_SUCCESS, payload: { tabs } };
}
